import { useId, useState, type ReactNode } from 'react';
import { Info } from 'lucide-react';

/**
 * BİLGİ DÜĞMESİ — sayfa başlığının yanındaki (i) simgesi; üstüne gelince (veya
 * klavyeyle odaklanınca) ekranın NE İŞE YARADIĞINI anlatan bir balon açar.
 *
 * NEDEN AYRI BİLEŞEN: bu açıklamalar daha önce yerel `title` özniteliğindeydi —
 * tarayıcı ipucu ~1 sn gecikmeli, stilsiz ve mobilde hiç yok; kullanıcı geri
 * bildirimi "ekranların ne işe yaradığını anlayamadım" idi. Balon her sayfada
 * aynı görünmeli, bu yüzden stil tek yerde durur.
 *
 * ERİŞİLEBİLİRLİK: gerçek bir `<button>`tır (Tab ile gelinir), balon
 * `role="tooltip"` + `aria-describedby` ile düğmeye bağlanır; Escape kapatır.
 * Hover VE focus aynı durumu sürer — fare ile klavye aynı bilgiyi görür.
 *
 * KONUM: balon simgenin altına, sola hizalı açılır (`left-0 top-full`). Simge
 * her sayfada başlığın yanında yani sol kıyıya yakın durduğu için sağdan taşma
 * riski yoktur; yine de `max-w-[80vw]` dar ekranlarda emniyet kemeridir.
 */
export default function BilgiDugmesi({
  testId = 'bilgi-dugmesi',
  children,
}: {
  /** e2e/DOM sözleşmesi — balon `${testId}-balon` id'siyle çizilir. */
  testId?: string;
  /** Balon içeriği: ekranın ne işe yaradığını anlatan 1-3 cümle. */
  children: ReactNode;
}) {
  const [acik, setAcik] = useState(false);
  const balonId = useId();

  return (
    <span className="relative inline-flex">
      <button
        type="button"
        data-testid={testId}
        aria-label="Bu ekran ne işe yarar?"
        aria-describedby={acik ? balonId : undefined}
        onMouseEnter={() => setAcik(true)}
        onMouseLeave={() => setAcik(false)}
        onFocus={() => setAcik(true)}
        onBlur={() => setAcik(false)}
        onKeyDown={(event) => {
          if (event.key === 'Escape') setAcik(false);
        }}
        className="inline-flex cursor-help items-center text-[#9ca3af] transition-colors hover:text-[#4b5563] focus:outline-none focus-visible:text-[#4b5563]"
      >
        <Info className="h-4 w-4" />
      </button>

      {acik ? (
        <span
          id={balonId}
          role="tooltip"
          data-testid={`${testId}-balon`}
          className="absolute left-0 top-full z-50 mt-2 block w-[320px] max-w-[80vw] rounded-lg border border-[#e5e7eb] bg-white px-3.5 py-3 text-[12px] font-normal leading-relaxed text-[#374151] shadow-lg"
        >
          {children}
        </span>
      ) : null}
    </span>
  );
}
